module.exports = __webpack_public_path__ + "media/morro_dos_anjos.5135a2aa.mp4";